import { render, staticRenderFns } from "./ModalHomeCategoryService.vue?vue&type=template&id=4515deaf"
import script from "./ModalHomeCategoryService.vue?vue&type=script&lang=js"
export * from "./ModalHomeCategoryService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports